import { MarketBasketStatus, MarketBasketSummary } from '@domain'

export const marketBasket = {
	id: 2323232323,
	activeCustomersOnly: false,
	analysisError: null,
	analyst: 'Iggy Pop',
	analystId: 23,
	assignedAnalyst: {
		id: 23,
		firstName: 'Iggy',
		lastName: 'Pop',
		displayName: 'Iggy Pop',
		email: 'iggy.pop@stooges.com',
		profilePic: '',
	},
	analysisWarning: null,
	basketType: 'INTERNAL',
	bepBrand: 'Dining Alliance',
	caseIdLink:
		'https://diningalliance--full.sandbox.lightning.force.com/lightning/r/Case/SF123456g/view',
	categoriesFilter: null,
	createdAt: '2025-04-03T20:19:27.017787Z',
	createdByDisplayName: 'Iggy Pop',
	currency: 'USD',
	dateRangeStart: '2024-01-01',
	dateRangeEnd: '2024-10-31',
	deleted: false,
	displayName: 'Mocked Market Basket DisplayName',
	distributorsFilter: null,
	effectiveDate: '2023-01-01',
	ignoreDistributorRestrictions: false,
	internalCustomers: [
		{
			plid: 'CL-1158897',
			children: [],
			name: 'Davios (PA)',
			id: 504834,
		},
	],
	manufacturersFilter: null,
	marketSegment: 'HEALTHCARE',
	markupAmount: 10,
	markupType: 'PERCENT_MARKUP',
	markupsByCategory: null,
	matchType: 'EXACT',
	name: 'Mocked Market Basket',
	processingStatus: 'CONDENSING',
	progress: 0.15,
	purchaseDateRangeEnd: '2024-10-31',
	purchaseDateRangeStart: '2024-01-01',
	reviewSavingsTolerance: null,
	salesforceCaseId: 'SFmock',
	salesforceCaseNumber: '100001',
	sourceType: 'ANALYST',
	status: MarketBasketStatus.PROCESSING,
	targetDistributor: null,
	targetManufacturers: null,
	tier: 'Tier 1',
	skippedTasks: false,
}

export const marketBasketExport = {
	id: 23,
	marketBasketId: 23,
	progress: 50,
	url: 'file:/Users/roy.ledford/proj/artemis-api/local-storage/exports/1263/market_basket__davios-(pa)__2025-10-06_16-32.xlsx',
	status: 'COMPLETED',
	createdAt: '2025-10-06T16:32:40.153022-04:00',
	updatedAt: '2025-10-06T16:32:41.219455-04:00',
}

export const marketBasketSettings = {
	packSize: {
		low: 0.05,
		high: 100,
	},
	switchDirectDeals: true,
	sameManufacturer: true,
	restrictedManufacturer: true,
	highestRebate: {
		enabled: true,
		value: 4,
	},
	programs: {
		direct: true,
		beBrandExtendable: true,
		bePlatform: true,
		entegra: true,
	},
	tier: 'Tier 1',
	caseQty: {
		enabled: true,
		value: 100,
	},
	purchaseQuantity: {
		enabled: false,
		value: 100,
	},
	savingsMoreThan: {
		type: 'PERCENT',
		value: 50,
	},
	groupBy: 'CUSTOMER_LOCATION',
	highVolumeMfr: {
		enabled: true,
		cases: 100,
		spend: 1000,
	},
	preferExactMatch: false,
	annualizationMonths: 12,
}

export const marketBaskets: MarketBasketSummary[] = [
	{
		id: 100001,
		name: 'Blondie - Parallel Lines',
		displayName: 'Blondie - Parallel Lines',
		salesforceCaseId: 'SF100001',
		salesforceCaseNumber: '100001',
		bepBrand: 'Consolidated Concepts',
		status: MarketBasketStatus.COMPLETED,
		processingStatus: 'FINISHED',
		progress: 1,
		analysisError: null,
		analysisWarning: null,
		createdAt: '2025-01-11T00:00:00+00:00',
		completedAt: '2025-01-11T04:30:00+00:00',
		deleted: false,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'Debbie Harry',
		assignedAnalyst: {
			id: 1,
			firstName: 'Debbie',
			lastName: 'Harry',
			displayName: 'Debbie Harry',
			email: 'debbie.harry@blondie.com',
			profilePic: '',
		},
		createdByDisplayName: 'Debbie Harry',
		tier: 'Tier 1',
		caseIdLink: 'https://example.my.salesforce.com/SF100001',
		basketType: 'INTERNAL',
		sourceType: 'ANALYST',
	},
	{
		id: 100002,
		name: 'Talking Heads - Remain in Light',
		displayName: 'Talking Heads - Remain in Light',
		salesforceCaseId: 'SF100002',
		salesforceCaseNumber: '100002',
		bepBrand: 'Dining Alliance',
		status: MarketBasketStatus.PENDING,
		processingStatus: 'GATHERING',
		progress: null,
		analysisError: null,
		analysisWarning: null,
		createdAt: '2025-01-12T00:00:00+00:00',
		completedAt: null,
		deleted: false,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'David Byrne',
		assignedAnalyst: {
			id: 2,
			firstName: 'David',
			lastName: 'Byrne',
			displayName: 'David Byrne',
			email: 'david.byrne@talkingheads.com',
			profilePic: '',
		},
		createdByDisplayName: 'David Byrne',
		tier: 'Tier 2',
		caseIdLink: 'https://example.my.salesforce.com/SF100002',
		basketType: 'INTERNAL',
		sourceType: 'PALANTIR',
	},
	{
		id: 100003,
		name: 'Fleetwood Mac - Rumours',
		displayName: 'Fleetwood Mac - Rumours',
		salesforceCaseId: 'SF100003',
		salesforceCaseNumber: '100003',
		bepBrand: 'Sourcing1',
		status: MarketBasketStatus.PROCESSING,
		processingStatus: 'MATCHING',
		progress: 0.42,
		analysisError: null,
		analysisWarning: null,
		createdAt: '2025-01-13T00:00:00+00:00',
		completedAt: null,
		deleted: false,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'Stevie Nicks',
		assignedAnalyst: {
			id: 3,
			firstName: 'Stevie',
			lastName: 'Nicks',
			displayName: 'Stevie Nicks',
			email: 'stevie.nicks@fleetwoodmac.com',
			profilePic: '',
		},
		createdByDisplayName: 'Stevie Nicks',
		tier: 'Tier 1',
		caseIdLink: 'https://example.my.salesforce.com/SF100003',
		basketType: 'UPLOADED',
		sourceType: 'ANALYST',
	},
	{
		id: 100004,
		name: 'Kate Bush - The Dreaming',
		displayName: 'Kate Bush - The Dreaming',
		salesforceCaseId: 'SF100004',
		salesforceCaseNumber: '100004',
		bepBrand: 'Consolidated Concepts',
		status: MarketBasketStatus.ANALYZED,
		processingStatus: 'FLAGGING',
		progress: 1,
		analysisError: null,
		analysisWarning: null,
		createdAt: '2025-01-14T00:00:00+00:00',
		completedAt: null,
		deleted: false,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'Kate Bush',
		assignedAnalyst: {
			id: 4,
			firstName: 'Kate',
			lastName: 'Bush',
			displayName: 'Kate Bush',
			email: 'kate.bush@thedreaming.com',
			profilePic: '',
		},
		createdByDisplayName: 'Kate Bush',
		tier: 'Tier 3',
		caseIdLink: 'https://example.my.salesforce.com/SF100004',
		basketType: 'INTERNAL',
		sourceType: 'ANALYST',
	},
	{
		id: 100005,
		name: 'Ween - The Mollusk',
		displayName: 'Ween - The Mollusk',
		salesforceCaseId: 'SF100005',
		salesforceCaseNumber: '100005',
		bepBrand: 'Dining Alliance',
		status: MarketBasketStatus.FAILED,
		processingStatus: 'CORRELATING',
		progress: null,
		analysisError: 'Unable to match purchases to distributor products',
		analysisWarning: null,
		createdAt: '2025-01-15T00:00:00+00:00',
		completedAt: null,
		deleted: false,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'Gene Ween',
		assignedAnalyst: {
			id: 5,
			firstName: 'Gene',
			lastName: 'Ween',
			displayName: 'Gene Ween',
			email: 'gene.ween@ween.com',
			profilePic: '',
		},
		createdByDisplayName: 'Gene Ween',
		tier: 'Tier 2',
		caseIdLink: 'https://example.my.salesforce.com/SF100005',
		basketType: 'INTERNAL',
		sourceType: 'PALANTIR',
	},
	{
		id: 100006,
		name: 'Rilo Kiley - Take Offs',
		displayName: 'Rilo Kiley - Take Offs',
		salesforceCaseId: 'SF100006',
		salesforceCaseNumber: '100006',
		bepBrand: 'Consolidated Concepts',
		status: MarketBasketStatus.COMPLETED,
		processingStatus: 'PRICING',
		progress: 1,
		analysisError: null,
		analysisWarning: null,
		createdAt: '2025-01-16T00:00:00+00:00',
		completedAt: '2025-01-16T06:15:00+00:00',
		deleted: true,
		dateRangeStart: '2024-01-01',
		dateRangeEnd: '2024-10-31',
		effectiveDate: '2025-01-01',
		analyst: 'Jenny Lewis',
		assignedAnalyst: {
			id: 6,
			firstName: 'Jenny',
			lastName: 'Lewis',
			displayName: 'Jenny Lewis',
			email: 'jenny.lewis@rilokiley.com',
			profilePic: '',
		},
		createdByDisplayName: 'Jenny Lewis',
		tier: 'Tier 1',
		caseIdLink: 'https://example.my.salesforce.com/SF100006',
		basketType: 'UPLOADED',
		sourceType: 'ANALYST',
	},
]

export const marketBasketsRes = {
	data: marketBaskets,
	pagination: {
		page: 1,
		pageSize: 100,
		total: marketBaskets.length,
		totalPages: 1,
	},
}

export const marketBasketPurchases = {
	purchases: [
		{
			id: '1',
			description: 'TEST ITEM 1',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: false,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'not found',
		},
		{
			id: '2',
			description: 'TEST ITEM 2',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: true,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'not found',
		},
		{
			id: '3',
			description: 'TEST ITEM 3',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: false,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'opportunity',
		},
		{
			id: '4',
			description: 'TEST ITEM 4',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: true,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'opportunity',
		},
		{
			id: '5',
			description: 'TEST ITEM 5',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: false,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
		{
			id: '6',
			description: 'TEST ITEM 6',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: true,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
		{
			id: '7',
			description: 'TEST ITEM 7',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: false,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
		{
			id: '8',
			description: 'TEST ITEM 8',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: true,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
		{
			id: '9',
			description: 'TEST ITEM 9',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: false,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
		{
			id: '10',
			description: 'TEST ITEM 10',
			packSize: '0/12 CT',
			qty: 0,
			inBasket: true,
			annualRebateSavings: '$0.00',
			annualPriceSavings: '$0.00',
			annualTotalSavings: '$0.00',
			savingsPercentage: '0%',
			volume: '$0.00',
			mfg: 'Test Manufacturer',
			brand: 'Test Brand',
			brandOwner: 'Test Brand Owner',
			purchasedQty: 0,
			purchasedPackSize: '0/12 CT',
			purchasedPrice: '$0.00',
			purchasedVolume: '$0.00',
			type: 'same item',
		},
	],
	metadata: {
		summary: {
			id: '0000000000',
			basketName: 'Test Basket',
			brand: 'CONSOLIDATED_CONCEPTS',
			tier: '1',
			basketType: 'Internal Customer',
			marketSegment: 'Casino and Gambling',
			caseIdUrl: 'https://www.google.com/',
		},
		kpis: {
			totalSpend: 100000,
			matchedSpend: 10000,
			matchedSpendPercentage: -100,
			savings: 1000,
			savingsPercentage: 100,
			sameItemSavings: 10200,
			sameItemSavingsPercentage: -100,
			sameItemPriceSavings: 100,
			sameItemPriceSavingsPercentage: -100,
			sameItemRebates: 1000,
			sameItemRebatesPercentage: -100,
			opportunitySavings: 10800000,
			opportunitySavingsPercentage: 100,
			opportunityPriceSavings: 10000,
			opportunityPriceSavingsPercentage: 0,
			opportunityRebates: 10,
			opportunityRebatesPercentage: 0,
		},
	},
}

// The detailed response for a single product and it's match
export const marketBasketPurchase = {
	customerLocationDmid: 123,
	customerName: 'Test Customer Location',
	customerParentDmid: 123,
	customerParentName: 'Test Customer Parent',
	derivedCost: null,
	directDeal: false,

	distributor: null, // FIXME (rl) I don't think this is used anymore'
	distributorLocationDmid: '1',
	distributorParentDmid: '1',
	distributorParentName: 'Test Distributor Location',
	distributorPlid: '1', // old
	distributorDpc: '1', // old
	distributorProductDmid: 123,

	flags: [
		{
			type: 'BAD_PACK_CONVERSION',
			description: 'The pack size conversion is outside normal values',
		},
	],
	groupKey: 'ddd, kkk, 333',
	groupKeyDisplayName: 'Test group key name',
	hasSimilarProducts: true,
	id: 'unknown',
	isInBasket: false,
	manufacturerProductDmid: 185466,
	marginMarkup: null,
	marketSegment: 'Casino and Gambling',

	matchedProduct: {
		type: 'SIMILAR_MATCH',
		manufacturerName: 'Flora Food Group BV',
		manufacturerPlid: 'MA-1042556',
		distributorProductDmid: 6796914,
		distributorLocationName: 'Harbor Foodservice - Kent, WA',
		distributorParentName: 'Harbor Foodservice',
		description: 'BUTTER 100% VEGAN PLANT UNSALTED',
		packSize: '36/1 LB',
		packSizeConversion: 1,
		packCvtModified: true,
		annualRebate: 561.1875,
		annualContractSavings: 37133.421,
		perCasePrice: 88.65,
		perCaseRebate: 1.025,
		dateRangeContractSavings: 203.4708,
		dateRangeRebateSavings: 3.075,
		dateRangeTotalSavings: 206.5458,
		annualPriceSavings: 37133.421,
		annualTotalSavings: 37694.6085,
		savingsPercentage: 44,
		stocked: true,
		brand: 'Violife',
		brandOwner: 'Manufacturer',
		category: 'Vegetarian Plant Based Products Refrigerated',
		mpc: '91304063',
		dpc: '014841',
		unit: 'FULL',
		caseVolume: 265.95,
		annualVolume: 48535.875,
		perCaseSavings: 67.8236,
		deviatedCost: 82.08,
		adjustedDeviatedCost: 82.08,
		qty: 3,
		score: 0.71483,
		matchedMarkupAmountOppy: 6.57,
		markupAmountFromOppy: 6.57,
		markupFromOppy: 8,
		markupTypeFromOppy: 'Percent Markup',
		markupAmount: null,
		markupDescription: null,
		estimatedFob: 4.25,
		packPurchaseQty: null,
		packSimilarQty: null,
		sellPriceOverride: null,
		sellPrice: 88.65,
		totalSellPrice: 88.65,
		calculationSummary:
			'STATUS INFORMATION\n Calculation Status: NO_TYPE_RESOLUTION - No price/cost info\n Successful: NO\n Run Status: NO_PRICE_OR_MARKUP - No price or markup found\n Contract Status: FOUND\n\nCALCULATION STEPS\n  No base cost or fixed price found\n\nFINAL CALCULATED PRICE\nNOT CALCULATED\n\nADDITIONAL DETAILS\nItem Unit Type: FULL\nProduct Specific Info Type: MFG_FIXED_COST',
		extendedPrice: null,
		manufacturerProductDmid: 1310410,
		deviatedPrice: null,
		rebateTermSetName: 'Flora Food Group BV All Tiers BEPL Rebate',
		savingsTermSetName: 'Flora Food Group BV BEPL All Tiers',
		exclusionSource: null,
	},
	purchasedProduct: {
		description: 'CONTAINER PAPER FBR 9X9 1C PFF',
		casePrice: 74.71,
		packSize: '2/75 CT',
		brandName: 'Sysco Earth Plus',
		brandOwner: 'Distributor',
		distributorProductDmid: 8126221,
		manufacturerName: 'Pactiv LLC',
		manufacturerPlid: 'MA-1000016',
		qtyPurchased: 178,
		totalWeight: null,
		totalPrice: 13298.26,
		pricePerCase: 74.71,
		caseVolume: 13298.26,
		annualVolume: 52192.1,
		dpc: '7218530',
		mpc: 'YMCH0901BSYS',
		currentProgramType: null,
		category: 'Container Paper',
		unit: 'FULL',
	},

	rebates: null,
	sellPrice: null,
	stocked: null,
}

// The detailed response for a single product and it's match with all flags present
export const marketBasketPurchaseAllFlags = {
	...marketBasketPurchase,
	flags: [
		{
			id: '1',
			type: 'badPackConversion',
			description: 'This was flagged due to incorrect Pack Size',
		},
		{
			id: '2',
			type: 'notStocked',
			description: 'Product is not stocked by the distributor',
		},
		{
			id: '3',
			type: 'savingsLimit',
			description: 'The amount of savings is over the defined threshold',
		},
		{
			id: '4',
			type: 'negativeSavings',
			description: 'The amount of savings is over the defined threshold',
		},
		{
			id: '5',
			type: 'privateLabel',
			description: 'The purchase is a distributor private label',
		},
		{
			id: '6',
			type: 'customerLabel',
			description: 'The purchase is a proprietary customer brand',
		},
		{
			id: '7',
			type: 'suggestStocking',
			description: 'Item is not stocked but volume is high',
		},
		{
			id: '8',
			type: 'betterThanDirect',
			description: 'The BEPL program is better than the existing Direct Deal',
		},
	],
}

export const purchaseFlags = new Map([
	['badPackConversion', 'This was flagged due to incorrect Pack Size'],
	['notStocked', 'Product is not stocked by the distributor'],
	['savingsLimit', 'The amount of savings is over the defined threshold'],
	['negativeSavings', 'The amount of savings is over the defined threshold'],
	['privateLabel', 'The purchase is a distributor private label'],
	['customerLabel', 'The purchase is a proprietary customer brand'],
	['suggestStocking', 'Item is not stocked but volume is high'],
	['betterThanDirect', 'The BEPL program is better than the existing Direct Deal'],
])

export const marketBasketSimilarProducts = [
	{
		id: 0,
		manufacturerName: 'Manufacturer 1 (All Chips)',
		brandName: 'Brand Name 1',
		annualPriceSavings: -100,
		annualRebateSavings: 0,
		savingsPerCase: -5,
		rebatePerCase: 0,
		qtyPurchased: 0,
		casePrice: 0,
		packSize: '12x1L',
		stocked: 'Yes',
		description:
			'Really long description to test text overflow/wrapping of long text in the table hopefully this is long enough',
		bestOverallSavings: true,
		bestRebate: true,
		exactMatch: true,
		inBasket: true,
		meetsCriteria: true,
		beplManufacturerProductItemId: 123456,
		purchaseManufacturerProductDmid: 123456,
		similarityScore: 0.95,
		packSizeConversion: 1,
		mpc: '1290123',
		beplDistributorProductItemId: 12345,
		hasPrograms: true,
		needsReview: false,
		brandType: 'manufacturer',
		originalPurchase: true,
		disqualificationReason: null,
		matched: true,
		flags: [],
	},
	{
		id: 1,
		manufacturerName: 'Manufacturer 2 (Longer name than usual for testing text truncate)',
		brandName: 'Brand Name 2',
		annualPriceSavings: 0,
		annualRebateSavings: 0,
		savingsPerCase: 0,
		rebatePerCase: 0,
		qtyPurchased: 0,
		casePrice: 0,
		packSize: '6x500g',
		stocked: 'No',
		description: 'Whole grain pasta',
		bestOverallSavings: false,
		bestRebate: false,
		exactMatch: true,
		inBasket: false,
		meetsCriteria: true,
		beplManufacturerProductItemId: 123456,
		purchaseManufacturerProductDmid: 123456,
		similarityScore: 0.8,
		packSizeConversion: 1,
		mpc: '555',
		beplDistributorProductItemId: 555,
		hasPrograms: true,
		needsReview: false,
		brandType: 'distributor',
		originalPurchase: false,
		disqualificationReason: null,
		matched: false,
		flags: [],
		switchCandidateInfo: 'DISTRIBUTOR_MISMATCH',
		distributorName: 'Mos Eisley Provisions',
	},
	{
		id: 2,
		manufacturerName: 'Manufacturer 3',
		brandName: 'Brand Name 3',
		annualPriceSavings: 0,
		annualRebateSavings: 0,
		savingsPerCase: 0,
		rebatePerCase: 0,
		qtyPurchased: 0,
		casePrice: 0,
		packSize: '24x330ml',
		stocked: 'Yes',
		description: 'Sparkling apple cider',
		bestOverallSavings: false,
		bestRebate: false,
		exactMatch: false,
		inBasket: true,
		meetsCriteria: true,
		beplManufacturerProductItemId: 123456,
		purchaseManufacturerProductDmid: 123456,
		similarityScore: 0.6,
		packSizeConversion: 0.5,
		mpc: '222',
		beplDistributorProductItemId: 222,
		hasPrograms: true,
		needsReview: false,
		brandType: 'manufacturer',
		originalPurchase: false,
		disqualificationReason: null,
		matched: false,
		flags: [],
	},
	{
		id: 3,
		manufacturerName: 'Manufacturer 4',
		brandName: 'Brand Name 4',
		annualPriceSavings: 0,
		annualRebateSavings: 0,
		savingsPerCase: 0,
		rebatePerCase: 0,
		qtyPurchased: 0,
		casePrice: 0,
		packSize: '4x2kg',
		stocked: 'No',
		description: 'Frozen wild salmon',
		bestOverallSavings: false,
		bestRebate: false,
		exactMatch: true,
		inBasket: false,
		meetsCriteria: false,
		beplManufacturerProductItemId: 123456,
		purchaseManufacturerProductDmid: 123456,
		similarityScore: 0.55,
		packSizeConversion: 1,
		mpc: '333',
		beplDistributorProductItemId: 333,
		hasPrograms: false,
		needsReview: true,
		brandType: 'distributor',
		originalPurchase: false,
		disqualificationReason: 'No programs available for this distributor',
		matched: false,
		flags: ['BAD_PACK_CONVERSION'],
	},
	{
		id: 4,
		manufacturerName: 'Manufacturer 5',
		brandName: 'Brand Name 5',
		annualPriceSavings: 0,
		annualRebateSavings: 0,
		savingsPerCase: 0,
		rebatePerCase: 0,
		qtyPurchased: 0,
		casePrice: 0,
		packSize: '20x200ml',
		stocked: 'No',
		description: 'Organic orange juice',
		bestOverallSavings: false,
		bestRebate: false,
		exactMatch: false,
		inBasket: true,
		meetsCriteria: false,
		beplManufacturerProductItemId: 123456,
		purchaseManufacturerProductDmid: 123456,
		similarityScore: 0.2,
		packSizeConversion: 1,
		mpc: '444',
		beplDistributorProductItemId: 444,
		hasPrograms: false,
		needsReview: false,
		brandType: 'customer',
		originalPurchase: false,
		disqualificationReason: null,
		matched: false,
		flags: [],
	},
]

export const distInvoiceLineIds = [111, 222, 333]
